// extracted by mini-css-extract-plugin
export var apartmentInput = "address-invoice-fields-module--apartment-input--Fw8p1";
export var cityInput = "address-invoice-fields-module--city-input--klSB7";
export var companyInput = "address-invoice-fields-module--company-input--ZkylI";
export var container = "address-invoice-fields-module--container--EKvx2";
export var houseInput = "address-invoice-fields-module--house-input--ypsze";
export var streetInput = "address-invoice-fields-module--street-input--SJ0KZ";
export var taxInput = "address-invoice-fields-module--tax-input--I3DTs";
export var zipInput = "address-invoice-fields-module--zip-input--MAktV";